import React from "react";
import "./Home.css";

export const Home = () => {
  return <div id="Home"></div>;
};

export default Home;
